import React, { useState, useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchBlog, resolveImg } from "../services/api";
import { ArrowRight, CalendarDays, User, Loader2 } from "lucide-react";

const cats = ["All", "Medals", "Running", "Teamwear"];

const Blog = () => {
  const [active, setActive] = useState("All");
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlog().then(setPosts).catch(() => setPosts([])).finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(
    () => (active === "All" ? posts : posts.filter((p) => p.category === active)),
    [active, posts]
  );
  const featured = posts[0];

  return (
    <div>
      <section className="bg-ink-gradient py-20">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <span className="text-[#E7C766] font-bold text-sm uppercase tracking-widest">Blog</span>
          <h1 className="font-display font-extrabold text-4xl md:text-5xl text-white mt-3">Insights & Buying Guides</h1>
          <p className="text-neutral-300 mt-4 max-w-2xl mx-auto">Tips, trends and guides for race organizers, sports clubs and promotional buyers.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-7xl mx-auto px-6">
          {loading ? (
            <div className="py-24 flex justify-center"><Loader2 className="w-8 h-8 text-[#C9A227] animate-spin" /></div>
          ) : (
            <>
              {featured && (
                <Link to={`/blog/${featured.slug}`} className="group grid lg:grid-cols-2 gap-8 mb-14 bg-white rounded-2xl overflow-hidden border border-neutral-100 card-lift">
                  <div className="h-72 lg:h-auto overflow-hidden"><img src={resolveImg(featured.image)} alt={featured.title} className="w-full h-full object-cover img-zoom" /></div>
                  <div className="p-8 flex flex-col justify-center">
                    <span className="text-[#C9A227] font-bold text-xs uppercase tracking-widest">{featured.category}</span>
                    <h2 className="font-display font-extrabold text-2xl md:text-3xl text-[#14171c] mt-3 group-hover:text-[#C9A227] transition-colors">{featured.title}</h2>
                    <p className="text-neutral-600 mt-4 leading-relaxed">{featured.excerpt}</p>
                    <div className="flex items-center gap-4 text-sm text-neutral-500 mt-5">
                      <span className="flex items-center gap-1.5"><CalendarDays className="w-4 h-4" /> {featured.date}</span>
                      <span className="flex items-center gap-1.5"><User className="w-4 h-4" /> {featured.author}</span>
                    </div>
                  </div>
                </Link>
              )}

              <div className="flex flex-wrap gap-2.5 mb-10">
                {cats.map((c) => (
                  <button key={c} onClick={() => setActive(c)}
                    className={`px-5 py-2 rounded-full text-sm font-semibold border transition-colors ${active === c ? "bg-[#C9A227] border-[#C9A227] text-white" : "bg-white border-neutral-200 text-neutral-700 hover:border-[#C9A227] hover:text-[#C9A227]"}`}>
                    {c}
                  </button>
                ))}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filtered.map((p) => (
                  <Link key={p.slug} to={`/blog/${p.slug}`} className="group bg-white rounded-2xl overflow-hidden border border-neutral-100 card-lift">
                    <div className="h-52 overflow-hidden"><img src={resolveImg(p.image)} alt={p.title} className="w-full h-full object-cover img-zoom" /></div>
                    <div className="p-6">
                      <span className="text-[#C9A227] font-bold text-xs uppercase tracking-widest">{p.category}</span>
                      <h3 className="font-display font-bold text-lg text-[#14171c] mt-2 leading-snug group-hover:text-[#C9A227] transition-colors">{p.title}</h3>
                      <p className="text-neutral-600 text-sm mt-3 line-clamp-2">{p.excerpt}</p>
                      <div className="flex items-center justify-between mt-5">
                        <span className="text-xs text-neutral-500">{p.date}</span>
                        <span className="inline-flex items-center gap-1 text-sm font-semibold text-[#C9A227]">Read <ArrowRight className="w-4 h-4" /></span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blog;
